(function () {
  'use strict';
  if (window.MSSmartSearch) return;
  const bound = new WeakSet();
  const controllers = new Set();
  const escape = value => String(value == null ? '' : value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function safeUrl(value, image) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value || '', location.origin);
      if (!/^https?:$/.test(url.protocol)) return '';
      if (!image && url.origin !== location.origin) return '';
      if (image && url.origin !== location.origin && !/(^|\.)shopify\.com$|(^|\.)shopifycdn\.(com|net)$/.test(url.hostname)) return '';
      return image ? url.href : url.pathname + url.search + url.hash;
    } catch (_) { return ''; }
  }
  function searchUrl(query) {
    const root = window.Shopify?.routes?.root || '/';
    return root.replace(/\/?$/, '/') + 'search?' + new URLSearchParams({q:query,type:'product,article,page'});
  }
  function imageUrl(item) {
    const source = item.image || item.featured_image;
    const url = safeUrl(typeof source === 'object' ? source?.url || source?.src : source, true);
    if (!url) return '';
    const sized = new URL(url); sized.searchParams.set('width', '160'); return sized.href;
  }
  function price(item) {
    const value = item.price_min ?? item.price;
    if (value === undefined || value === null || value === '') return '';
    const number = Number(value);
    if (!Number.isFinite(number) || number < 0) return '';
    return new Intl.NumberFormat('nb-NO', {style:'currency',currency:window.Shopify?.currency?.active || 'NOK', maximumFractionDigits:2}).format(number);
  }
  function itemHtml(item, type) {
    const url = safeUrl(item.url);
    if (!url) return '';
    const image = type === 'product' ? imageUrl(item) : '';
    const title = item.title || item.text || '';
    const variant = item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '';
    const meta = type === 'product' ? [variant, item.matchedSku ? 'Varenr. ' + item.matchedSku : '', item.vendor, price(item)].filter(Boolean).join(' · ') : '';
    return '<a class="ms-search-result ms-search-result--' + type + '" href="' + escape(url) + '">' +
      (image ? '<img src="' + escape(image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
      '<span><strong>' + escape(title) + '</strong>' + (meta ? '<small>' + escape(meta) + '</small>' : '') + '</span><span class="ms-search-result__arrow" aria-hidden="true">→</span></a>';
  }
  function group(title, items, type) {
    const content = (items || []).map(item => itemHtml(item, type)).join('');
    return content ? '<section class="ms-search-group"><h2>' + title + '</h2>' + content + '</section>' : '';
  }
  function resultHtml(data, query, limit, full) {
    const products = data.products || [];
    const suggestions = (data.suggestions || []).slice(0,3).map(s => {
      const text = typeof s === 'string' ? s : s.text || s.title;
      return text ? '<button type="button" data-search-query="' + escape(text) + '">' + escape(text) + '</button>' : '';
    }).join('');
    const groups = group('Kategorier', (data.collections || []).slice(0,full ? 12 : 3), 'collection') +
      group('Produkter', products.slice(0,limit), 'product') +
      group('Guider og veiledninger', (data.articles || []).slice(0,full ? 10 : 2), 'article') +
      group('Informasjon og hjelp', (data.pages || []).slice(0,full ? 10 : 2), 'page');
    const interpretation = data.interpretedQuery && data.interpretedQuery !== query
      ? '<p class="ms-search-notice">Søker også etter «' + escape(data.interpretedQuery) + '».</p>' : '';
    const partial = data.incomplete || data.coverage?.complete === false
      ? '<p class="ms-search-notice">Søket viser et begrenset utvalg akkurat nå. Du kan også bruke nettbutikkens søk.</p>' : '';
    const empty = !groups ? '<p class="ms-search-empty">Ingen forslag til dette søket. Prøv et produktnavn, varenummer eller et kortere søkeord.</p>' : '';
    return interpretation + partial + (suggestions ? '<div class="ms-search-suggestions" aria-label="Søkeforslag">' + suggestions + '</div>' : '') + groups + empty +
      (!full ? '<a class="ms-search-all" href="' + escape(searchUrl(query)) + '">Se flere treff for «' + escape(query) + '» <span aria-hidden="true">→</span></a>' : '');
  }
  function provider(query, signal) {
    if (!window.MSSearchProvider || typeof window.MSSearchProvider.search !== 'function') return Promise.reject(new Error('SEARCH_PROVIDER_UNAVAILABLE'));
    return window.MSSearchProvider.search({query,signal});
  }
  function bindForm(form) {
    if (bound.has(form)) return;
    bound.add(form);
    const shell = form.closest('[data-smart-search]');
    const input = form.querySelector('input[type="search"]');
    const panel = shell?.querySelector('[data-smart-search-panel]');
    const results = shell?.querySelector('[data-smart-search-results]');
    const status = shell?.querySelector('[data-smart-search-status]');
    const popular = shell?.querySelector('[data-smart-search-popular]');
    if (!input || !panel || !results) return;
    let timer, request, revision = 0, positionFrame = null;
    const listeners = [];
    let destroyed = false;
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push(() => target.removeEventListener(type, handler, options));
    }
    const initialPlaceholder = input.placeholder;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'dialog');
    input.setAttribute('aria-expanded', 'false');
    input.maxLength = 160;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Søkeforslag');
    const closeButton = document.createElement('button');
    closeButton.type = 'button'; closeButton.className = 'ms-search-close'; closeButton.textContent = 'Lukk søket';
    panel.prepend(closeButton);
    function cancel() { clearTimeout(timer); request?.abort(); revision += 1; }
    function close() {
      const wasOpen = !panel.hidden || shell.classList.contains('is-search-open');
      cancel(); panel.hidden = true; input.setAttribute('aria-expanded','false'); shell.classList.remove('is-search-open');
      if (positionFrame !== null) cancelAnimationFrame(positionFrame);
      positionFrame = null;
      if (wasOpen) document.dispatchEvent(new CustomEvent('ms:search-change', {detail:{shell,open:false}}));
    }
    function position() {
      if (destroyed || !shell.isConnected || panel.hidden || !shell.classList.contains('smart-search--header')) return;
      const top = form.getBoundingClientRect().bottom + 8;
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      panel.style.setProperty('--ms-search-top',top + 'px');
      panel.style.setProperty('--ms-search-height',Math.max(96,bottom - top - 12) + 'px');
    }
    const controller = { shell, close, position, destroy() {
      if (destroyed) return;
      destroyed = true;
      close();
      listeners.forEach(remove => remove());
      closeButton.remove();
      bound.delete(form);
      controllers.delete(controller);
    }};
    controllers.add(controller);
    function open() {
      if (destroyed || !shell.isConnected) return;
      controllers.forEach(c => { if (c.shell !== shell) c.close(); });
      panel.hidden = false; input.setAttribute('aria-expanded','true'); shell.classList.add('is-search-open');
      document.dispatchEvent(new CustomEvent('ms:search-open', {detail:{shell}}));
      document.dispatchEvent(new CustomEvent('ms:search-change', {detail:{shell,open:true}}));
      position();
      if (positionFrame !== null) cancelAnimationFrame(positionFrame);
      positionFrame = requestAnimationFrame(() => { positionFrame = null; position(); });
    }
    function visibleLinks() { return [...panel.querySelectorAll('a[href], button[data-search-query]')].filter(el => el.getClientRects().length); }
    async function run(query, id) {
      request = new AbortController();
      try {
        const data = await provider(query, request.signal);
        if (destroyed || !shell.isConnected || id !== revision || panel.hidden || input.value.trim() !== query) return;
        results.innerHTML = resultHtml(data,query,5,false);
        status.textContent = (data.products || []).length ? 'Forslag til søket ditt' : 'Søket er klart';
      } catch (error) {
        if (destroyed || !shell.isConnected || id !== revision || panel.hidden || error?.name === 'AbortError') return;
        status.textContent = 'Forslagene kunne ikke hentes.';
        results.innerHTML = '<a class="ms-search-all" href="' + escape(searchUrl(query)) + '">Søk i nettbutikken etter «' + escape(query) + '»</a>';
      }
    }
    function schedule() {
      if (destroyed || !shell.isConnected) return;
      cancel();
      // These search forms have no reset action; cache resets should retain the current query.
      input.defaultValue = input.value;
      const query = input.value.trim();
      results.textContent = ''; status.textContent = '';
      if (popular) popular.hidden = query.length >= 2;
      open();
      if (query.length < 2) return;
      status.textContent = 'Søker …';
      const id = revision;
      timer = setTimeout(() => run(query,id),180);
    }
    listen(input, 'input',schedule);
    listen(input, 'focus',() => {
      input.placeholder = shell.dataset.focusPlaceholder || initialPlaceholder;
      schedule();
    });
    listen(input, 'blur',() => { input.placeholder = initialPlaceholder; });
    listen(input, 'click',() => { if (panel.hidden) schedule(); });
    listen(closeButton, 'click',() => { input.focus(); close(); });
    listen(shell, 'keydown',event => {
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault(); event.stopPropagation(); input.focus(); close(); return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      if (panel.hidden) { if (event.target === input) schedule(); return; }
      const links = visibleLinks(); if (!links.length) return;
      event.preventDefault();
      const index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowUp' && index === 0) { input.focus(); return; }
      const next = index < 0 ? (event.key === 'ArrowDown' ? 0 : links.length-1) : Math.min(links.length-1,index+(event.key === 'ArrowDown'?1:-1));
      links[next].focus();
    });
    listen(shell, 'click',event => {
      const button = event.target.closest('[data-search-query]');
      if (!button) return;
      input.value = button.dataset.searchQuery; input.focus(); schedule();
    });
    listen(form, 'submit',close);
  }
  function bindPage(page) {
    if (bound.has(page)) return; bound.add(page);
    if (Number(new URLSearchParams(location.search).get('page') || 1) > 1) return;
    const query = page.dataset.query?.trim(); if (!query) return;
    const root = page.querySelector('[data-ms-search-page-results]');
    const items = root?.querySelector('[data-ms-search-page-items]');
    const status = root?.querySelector('[data-ms-search-page-status]');
    const more = root?.querySelector('[data-ms-search-page-more]');
    const native = page.querySelector('[data-ms-search-native]');
    if (!items) return;
    let nativeUsed = false;
    native?.addEventListener('pointerdown',() => { nativeUsed = true; },{once:true});
    native?.addEventListener('focusin',() => { nativeUsed = true; },{once:true});
    const request = new AbortController();
    window.addEventListener('pagehide',() => request.abort(),{once:true});
    provider(query,request.signal).then(data => {
      if (!page.isConnected) return;
      let limit = 20;
      function render() {
        items.innerHTML = resultHtml(data,query,limit,true);
        more.hidden = (data.products || []).length <= limit;
      }
      render(); root.hidden = false;
      status.textContent = 'Forslag til «' + query + '»';
      // Preserve Shopify's full results, pagination and product-card actions as an explicit fallback.
      if (native && !nativeUsed && !native.contains(document.activeElement) && (data.products?.length || data.collections?.length || data.articles?.length || data.pages?.length)) {
        native.open = false; native.querySelector('summary').hidden = false;
      }
      more.addEventListener('click',() => { limit += 20; render(); });
      items.addEventListener('click',event => {
        const button = event.target.closest('[data-search-query]');
        if (button) location.assign(searchUrl(button.dataset.searchQuery));
      });
    }).catch(() => { /* Server-rendered search stays usable. */ });
  }
  function bind(root) {
    controllers.forEach(c => { if (!c.shell.isConnected) c.destroy(); });
    (root || document).querySelectorAll('[data-search-form]').forEach(bindForm);
    (root || document).querySelectorAll('[data-ms-search-page]').forEach(bindPage);
  }
  document.addEventListener('shopify:section:unload',event => controllers.forEach(c => {
    if (event.target === c.shell || event.target.contains(c.shell)) c.destroy();
  }));
  document.addEventListener('shopify:section:load',event => bind(event.target));
  document.addEventListener('pointerdown',event => controllers.forEach(c => { if (!c.shell.contains(event.target)) c.close(); }));
  // Safari may focus a containing drawer/body before a native result-link click.
  // Keep that ancestor transition open; outside pointer actions and focus on other controls still close.
  document.addEventListener('focusin',event => controllers.forEach(c => {
    if (!c.shell.contains(event.target) && !event.target.contains?.(c.shell)) c.close();
  }));
  const reposition = () => controllers.forEach(c => c.position());
  // The scroll listener can run before the sticky header's animation frame.
  // Remeasure synchronously after its class transition, before the next paint.
  document.addEventListener('ms:header-layout-change',reposition);
  window.addEventListener('resize',reposition,{passive:true});
  window.addEventListener('scroll',reposition,{passive:true});
  window.visualViewport?.addEventListener('resize',reposition,{passive:true});
  document.addEventListener('ms:navigation-change',event => {
    if (event.detail?.open && event.detail.mode === 'desktop') controllers.forEach(c => { if (c.shell.classList.contains('smart-search--header')) c.close(); });
    if (!event.detail?.open) controllers.forEach(c => { if (c.shell.closest('[data-ms-premium-nav-drawer]')) c.close(); });
  });
  document.addEventListener('keydown',event => {
    if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey || event.defaultPrevented) return;
    if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
    const drawer = document.querySelector('[data-ms-premium-nav-drawer]:not([hidden])');
    const modal = [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].find(el => el.getClientRects().length && !el.hidden);
    if (modal && modal !== drawer) return;
    const input = (drawer || document).querySelector(drawer ? '[data-smart-search-input]' : '.smart-search--header [data-smart-search-input]');
    if (!input || !input.getClientRects().length) return;
    event.preventDefault(); input.focus();
  });
  window.MSSmartSearch = {bind};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => bind(document));
  else bind(document);
}());
